
const is = require('../../plugins/helper/is')
const { listen } = require('../../plugins/event/listen')
const Swal = require('../../plugins/sweet/Alert').default

export const defaultSwal = {
  toast: true,
  timer: 2000,
  position: 'top-start',
  showConfirmButton: false,
  timerProgressBar: false,
}

/**
 * @param {HTMLElement} input
 * @param {String} title
 */
export const setAsLoaded = (input, title) => {
  is.addClass(input.parentNode, 'disable-file-select')
  is.setAttribute(input, 'disabled', 'disabled')
  const Toast = Swal.mixin(defaultSwal)
  Toast.fire({
    icon: 'info',
    title,
  })
}

listen('#load-sign-document #pills-tab a[data-toggle="pill"]', 'click', function() {
  const inputs = ['sign-document', 'sign-document-online']
  inputs.forEach(function (input) {
    if (is.node(`#${input}`)) {
      const document = is.getNode(`#${input}`)
      document.value = ''
    }
  })

  return false
})
